module.exports = __webpack_public_path__ + "img/12226_26.3ee90222.png";